import { defineStore } from 'pinia'
import { actions, getters, state } from './ext/itemsForResource.js'
import axios from 'axios'

export const useTeamPublicStore = (id = 'default') => {
  return defineStore({
    id: `teamPublic_${id}`,
    state: () => ({
      ...state,
      items: [],
      api: '/api/v1/teams-public',
    }),
    getters: {
      ...getters,
      featured(state) {
        return state.items.filter(item => item.featured)
      },
    },
    actions: {
      ...actions,
      async fetchItemByOldId(oldId) {
        const { data } = await axios.get('/api/v1/teams-public', {
          params: {
            old_id: oldId
          }
        })
        if(data.data && data.data.length > 0 && data.data[0].old_id === oldId) {
          return data.data[0]
        }
        return null
      },
      async startDonation(payload) {
        const { data } = await axios.post(this.api + '/' + payload.team_id + '/donations', payload)
        return data
      },
      async confirmDonation(payload) {
        const { data } = await axios.post(this.api + '/' + payload.team_id + '/donations/' + payload.donation_id + '/confirm', payload)
        return data
      },
    }
  })()
}
